export enum GaugeType {
    None = "None",
    Gauge = "Gauge",
    Chrono = "Chrono",
}